import { QueryObserverResult, useInfiniteQuery } from 'react-query';
import useApiService from '../utilities/useApiService';
import { QueryHandler } from '../network/models/QueryHandlers';
import { AxiosResponse } from 'axios';
import { useState } from 'react';

export const useManufacturers = (
   searchTermQuery: string,
   handlers?: QueryHandler<any | undefined, AxiosResponse<any>>
): [
   any | undefined,
   (searchTermQuery: string) => void,
   Omit<QueryObserverResult<any>, 'data' | 'refetch'> & {
      fetchNextPage: () => Promise<any>;
      hasNextPage: boolean | undefined;
      isFetchingNextPage: boolean;
   }
] => {
   const { getMethod } = useApiService();
   const [searchTerm, setSearchTerm] = useState(searchTermQuery);

   const {
      data,
      fetchNextPage,
      hasNextPage,
      isFetchingNextPage,
      ...state
   } = useInfiniteQuery(
      ['/items/manufacturers', searchTerm],
      async ({ signal, pageParam = 0 }) => {
         if (handlers?.beforeQuery) handlers.beforeQuery();
         const res = await getMethod('/items/manufacturers', {
            signal,
            params: { query: searchTerm, page: pageParam, size: 50 },
         });
         return res.data as string[];
      },
      {
         getNextPageParam: (lastPage, allPages) =>
            (lastPage && lastPage.length === 50 ? allPages.length : undefined),
         keepPreviousData: true,
         staleTime: 60_000,
         onError: handlers?.onError,
         onSuccess: handlers?.onSuccess,
         onSettled: handlers?.onSettled,
      }
   );

   const flat = data?.pages ? ([] as string[]).concat(...data.pages) : data as any;

   return [flat, setSearchTerm, { ...state as any, fetchNextPage, hasNextPage, isFetchingNextPage }];
};
